export default "__VITE_ASSET__BhQTpAQ$__"